module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('race-header', {
    attrs: {
      "title": "Update Race"
    }
  }), _vm._v(" "), (_vm.update) ? _c('custom-form', [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Name",
      "name": "name",
      "data-vv-value-path": "input",
      "data-vv-name": "name",
      "error-message": "Fill in the name",
      "has-error": _vm.errors.has('name'),
      "required": true
    },
    model: {
      value: (_vm.update.name),
      callback: function($$v) {
        _vm.$set(_vm.update, "name", $$v)
      },
      expression: "update.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.update.description),
      expression: "update.description"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('description')
    },
    attrs: {
      "data-vv-rules": "required",
      "name": "description",
      "rows": "6",
      "id": "txtArea",
      "required": ""
    },
    domProps: {
      "value": (_vm.update.description)
    },
    on: {
      "keypress": _vm.onDescriptionChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.update, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('date-time-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": ("Date - " + (_vm.getTimezone())),
      "name": "date",
      "data-vv-value-path": "startDate.time",
      "data-vv-name": "date",
      "error-message": "Fill in the date",
      "has-error": _vm.errors.has('date'),
      "required": true
    },
    model: {
      value: (_vm.update.date),
      callback: function($$v) {
        _vm.$set(_vm.update, "date", $$v)
      },
      expression: "update.date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Duration(in minutes):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.update.duration),
      expression: "update.duration"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('duration')
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "number",
      "step": "1",
      "min": "1",
      "max": "max_duration",
      "name": "duration",
      "required": ""
    },
    domProps: {
      "value": (_vm.update.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.update, "duration", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duration')),
      expression: "errors.has('duration')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the duration")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "100px"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("First Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.type),
      expression: "update.type"
    }],
    staticStyle: {
      "height": "33px"
    },
    attrs: {
      "label": "First Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "LIVE"
    }
  }, [_vm._v(" Live (Medal) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO_MEDAL"
    }
  }, [_vm._v(" No Medal ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON_DEMAND_MEDAL"
    }
  }, [_vm._v(" On demand (Medal)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON_DEMAND_NO_MEDAL"
    }
  }, [_vm._v(" On demand (No Medal) ")])])]), _vm._v(" "), (_vm.update.type == 'ON_DEMAND_MEDAL' || _vm.update.type == 'ON_DEMAND_NO_MEDAL') ? _c('div', {
    staticStyle: {
      "margin-right": "100px"
    }
  }, [_c('race-media', {
    attrs: {
      "label": "On demand File",
      "name": "media",
      "data-vv-value-path": "input",
      "data-vv-name": "media",
      "error-message": "Fill in the audio",
      "has-error": _vm.errors.has('media'),
      "required": false
    },
    on: {
      "saved": _vm.loadAudio
    },
    model: {
      value: (_vm.update.audioFileUrl),
      callback: function($$v) {
        _vm.$set(_vm.update, "audioFileUrl", $$v)
      },
      expression: "update.audioFileUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.update.type == 'ON_DEMAND_MEDAL' || _vm.update.type == 'ON_DEMAND_NO_MEDAL') &&
    _vm.update.audioFileUrl) ? _c('div', [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Current On demand File: ")]), _vm._v(" "), _c('audio', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "id": "ondemand-audio",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.update.audioFileUrl,
      "type": "audio/mp3"
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Second Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.secondType),
      expression: "update.secondType"
    }],
    attrs: {
      "label": "Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "secondType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.raceTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.name
      }
    }, [_vm._v(_vm._s(type.englishText))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Third Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.thirdType),
      expression: "update.thirdType"
    }],
    attrs: {
      "label": "Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "thirdType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" NONE ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO_MEDAL"
    }
  }, [_vm._v(" NO MEDAL ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoL"
    }
  }, [_vm._v(" L ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoI"
    }
  }, [_vm._v(" I ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoV"
    }
  }, [_vm._v(" V ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoE"
    }
  }, [_vm._v(" E ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LIVE_60MIN"
    }
  }, [_vm._v(" 60MIN_MEDAL ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoU"
    }
  }, [_vm._v(" U ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoR"
    }
  }, [_vm._v(" R ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MEDAL_20K"
    }
  }, [_vm._v(" 20Km Medal ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Channel:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.mobileChannelToPlay),
      expression: "update.mobileChannelToPlay"
    }],
    staticStyle: {
      "width": "9%"
    },
    attrs: {
      "label": "Channel",
      "name": "channel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "mobileChannelToPlay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.channels.audioChannelA
    }
  }, [_vm._v(" A ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelB
    }
  }, [_vm._v(" B ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelC
    }
  }, [_vm._v(" C ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelD
    }
  }, [_vm._v(" D ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Language:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.language),
      expression: "update.language"
    }],
    attrs: {
      "label": "Language",
      "name": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('option', {
      domProps: {
        "value": locale.id
      }
    }, [_vm._v(_vm._s(locale.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticClass: "actionImgContent"
  }, [_c('div', {
    staticClass: "form__group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("RSVP Limit:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.update.rsvp_limit),
      expression: "update.rsvp_limit"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('rsvp_limit')
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "number",
      "step": "1",
      "min": "1",
      "max": "max_duration",
      "name": "rsvp_limit",
      "required": ""
    },
    domProps: {
      "value": (_vm.update.rsvp_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.update, "rsvp_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rsvp_limit')),
      expression: "errors.has('rsvp_limit')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the RSVP limit")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "35rem"
    }
  }, [(_vm.update.actionImageUrl != '') ? _c('div', {
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', [_c('p', [_vm._v("Current Action Image:")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "border-radius": "50%",
      "border": "2px solid black"
    },
    attrs: {
      "src": _vm.update.actionImageUrl,
      "width": "100px",
      "height": "100px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "auto"
    }
  }, [_c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../assets/delete2.png")
    },
    on: {
      "click": function($event) {
        _vm.removeActionImg()
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticClass: "actionImgContent"
  }, [_c('div', {
    staticClass: "form__group",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Action URL:")]), _vm._v(" "), _c('text-field', {
    attrs: {
      "name": "endSessionUrl",
      "data-vv-value-path": "input",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.update.endSessionUrl),
      callback: function($$v) {
        _vm.$set(_vm.update, "endSessionUrl", $$v)
      },
      expression: "update.endSessionUrl"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "35rem"
    }
  }, [_c('race-photo', {
    attrs: {
      "label": "Action Image",
      "name": "actionImage",
      "data-vv-value-path": "input",
      "data-vv-name": "actionImage",
      "error-message": "Fill in the photo with size below 200 Kb",
      "has-error": _vm.errors.has('actionImage'),
      "required": false
    },
    model: {
      value: (_vm.update.actionImageUrl),
      callback: function($$v) {
        _vm.$set(_vm.update, "actionImageUrl", $$v)
      },
      expression: "update.actionImageUrl"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form__group race-tags"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v(" Tags:")]), _vm._v(" "), _c('selectize', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "options": _vm.tagsOptions,
      "multiple": "",
      "size": "1",
      "isRunnerTag": false,
      "isRaceTag": true,
      "raceId": this.$route.params.raceId,
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.update.imageUrl != '') ? _c('div', [_c('p', [_vm._v("Current photo race:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.update.imageUrl,
      "width": "200px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('upload-photo', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Photo",
      "name": "photo",
      "data-vv-value-path": "input",
      "data-vv-name": "photo",
      "error-message": "Fill in the photo with size below 200 Kb",
      "has-error": _vm.errors.has('photo'),
      "required": true
    },
    model: {
      value: (_vm.update.imageUrl),
      callback: function($$v) {
        _vm.$set(_vm.update, "imageUrl", $$v)
      },
      expression: "update.imageUrl"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v(" Trainer:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trainerId),
      expression: "trainerId"
    }],
    staticClass: "trainer-list",
    attrs: {
      "label": "Trainer",
      "name": "Trainer"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trainerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeTrainer]
    }
  }, _vm._l((_vm.trainerList), function(trainer, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": trainer.id
      }
    }, [_vm._v(_vm._s(trainer.firstName))])
  }))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "submit-form"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("Update Race")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28415ea0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Races/Update.vue
// module id = 1649
// module chunks = 1